import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  ListQueryParams,
  UsersListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const USERS_LIST_QUERY_KEY = 'users_list';

export const useUsersListQuery = (url: string, queryParams: ListQueryParams) =>
  useQuery({
    queryKey: [USERS_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<UsersListResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
